import { api } from './client'

export interface NotificationSettings {
  sound: boolean
  vibration: boolean
  preview: boolean
  dnd_enabled: boolean
  dnd_start: string
  dnd_end: string
}

export interface PushToken {
  id: string
  device_name: string
  platform: string
  notifications_enabled: boolean
  sound_enabled: boolean
  created_at: string
}

export const notificationsApi = {
  getSettings: (): Promise<NotificationSettings> =>
    api.get('/v1/notifications/settings'),

  updateSettings: (settings: Partial<NotificationSettings>): Promise<NotificationSettings> =>
    api.put('/v1/notifications/settings', settings),

  listTokens: (): Promise<{ tokens: PushToken[] }> =>
    api.get('/v1/notifications/tokens'),

  removeToken: (tokenId: string): Promise<void> =>
    api.delete(`/v1/notifications/tokens/${tokenId}`),

  updateTokenSettings: (tokenId: string, settings: { notifications_enabled: boolean; sound_enabled: boolean }): Promise<void> =>
    api.patch(`/v1/notifications/tokens/${tokenId}`, settings),

  testPush: (): Promise<{ results: TestPushResult[] }> =>
    api.post('/v1/notifications/test-push', {}),
}

export interface TestPushResult {
  token_id: string
  platform: string
  device_name: string
  ok: boolean
  error?: string
}
